import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, cn } from '@costar-ui/cosmos';
import baseButton from './base-button.esm.js';

var tvObject = getTvObject(_objectSpread2(_objectSpread2({}, baseButton), {}, {
  base: cn(baseButton.base, 'rounded-lg').split(' ')
}));
var nextButton = tvObject;

export { nextButton as default };
//# sourceMappingURL=next-button.esm.js.map
